export function domReady() {
  return new Promise((resolve) => {
    document.addEventListener("DOMContentLoaded", resolve);
  });
}
